module.exports = "<footer class=\"footer\">\n  <div class=\"container-fluid\">\n    <div class=\"copyright pull-right\">\n      &copy;\n      <script>document.write(new Date().getFullYear());</script>, made with\n      <i class=\"fa fa-heart heart\"></i> by\n      <a href=\"https://www.mywaz.com\">WAZ</a>\n    </div>\n  </div>\n</footer>"


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/shared/footer/footer.component.html
// module id = ../../../../../src/app/shared/footer/footer.component.html
// module chunks = main